jQuery(document).ready(function($){
  $('.gs-testimonial-wrap').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    dots: true,
    autoplay: false,
    autoplaySpeed: 4000,
    adaptiveHeight: true
  });
});

$('.gs-testimonial-wrap-1').slick({
  vertical: true,
  slidesToShow: 3,      
  slidesToScroll: 1,   
  arrows: false,
  dots: false,
  pauseOnHover: true,
  infinite: true,
  speed: 5000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
});

$('.gs-testimonial-wrap-2').slick({
  vertical: true,
  slidesToShow: 3,      
  slidesToScroll: 1,   
  arrows: false,
  dots: false,
  pauseOnHover: true,
  infinite: true,
  speed: 5000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
});

$('.gs-testimonial-wrap-3').slick({
  vertical: true,
  slidesToShow: 3,      
  slidesToScroll: 1,   
  arrows: false,
  dots: false,
  pauseOnHover: true,
  infinite: true,
  speed: 5000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
});

$('.image-repeater').slick({
  slidesToShow: 3,      
  slidesToScroll: 1,   
  arrows: false,
  dots: false,
  pauseOnHover: true,
  infinite: true,
  speed: 5000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  variableWidth: true
});


// Product page Popup opener

const openBtn = document.getElementById("ProductPopup-popup");
  const closeBtn = document.getElementById("ModalClose-popup");
  const modal = document.getElementById("PopupModal-popup");

  openBtn.addEventListener("click", () => {
    modal.setAttribute("open", true);
  });

  closeBtn.addEventListener("click", () => {
    modal.removeAttribute("open");
  });

  // Close when clicking outside the content
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.removeAttribute("open");
    }
  });

  // Product Specifications Popup opener
const openSpecsBtn = document.getElementById("ProductPopup-specs");
const closeSpecsBtn = document.getElementById("ModalClose-specs");
const specsModal = document.getElementById("PopupModal-specs");

if (openSpecsBtn && closeSpecsBtn && specsModal) {
  openSpecsBtn.addEventListener("click", () => {
    specsModal.setAttribute("open", true);
  });

  closeSpecsBtn.addEventListener("click", () => {
    specsModal.removeAttribute("open");
  });

  // close when clicking outside modal content
  specsModal.addEventListener("click", (e) => {
    if (e.target === specsModal) {
      specsModal.removeAttribute("open");
    }
  });
}
